import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.PROFILE;

// create path router
const PATH_ROUTER_PROFILE = {
  DETAIL: "",
  EDIT: "edit"
};

// create path routes
const { EDIT } = PATH_ROUTER_PROFILE;
const PATH_ROUTES_PROFILE = {
  EDIT: (id: number) => `/${BASE}/${EDIT}/${id}`,
  DETAIL: (id: number) => `/${BASE}/${id}`
};

// export
const PROFILE_PATH = {
  ROUTES: PATH_ROUTES_PROFILE,
  ROUTER: PATH_ROUTER_PROFILE
};
export default PROFILE_PATH;
